import { Component, Input, OnChanges, HostBinding } from '@angular/core';
import { ValidationErrors } from '@angular/forms';
import { marker as _ } from '@biesbjerg/ngx-translate-extract-marker';

export const validatorMessages = {
  required: _('form-alert-message.required'),
  samePassword: _('form-alert-message.same-password'),
  userAdult: _('form-alert-message.user-adult'),
  maxlength: _('form-alert-message.max-length'),
  phoneNumber: _('form-alert-message.phone-number'),
  identityDocument: _('form-alert-message.identity-document'),
  dateInvalid: _('form-alert-message.date-invalid')
};

export enum TYPE_MESSAGES {
  INFO = 'info',
  ERROR = 'error',
  WARNING = 'warning',
  SUCCESS = 'success'
}

@Component({
  selector: 'my-account-form-alert-message',
  templateUrl: './form-alert-message.component.html',
  styleUrls: ['./form-alert-message.component.scss']
})
export class FormAlertMessageComponent implements OnChanges {
  @HostBinding('class.form-alert-message--none') hide: boolean;

  @Input() controlErrors: ValidationErrors;

  @Input() text: string;

  @Input() messageType: TYPE_MESSAGES;

  @Input() iconClass: string;

  @Input() showError: boolean;

  @Input() customError: string;

  message = null;

  values;

  type: TYPE_MESSAGES;

  constructor() {
    this.messageType = TYPE_MESSAGES.INFO;
  }

  ngOnChanges(): void {
    this.message = null;

    if (this.controlErrors && this.showError) {
      this.checkErrorControl(this.controlErrors);
    } else if (this.text) {
      this.checkText(this.text);
    }
    this.hide = !this.message;
  }

  private checkErrorControl(errors: ValidationErrors) {
    this.message = this.getErrorMessage(errors);
    this.type = TYPE_MESSAGES.ERROR;
  }

  private getErrorMessage(errors: ValidationErrors) {
    for (const propertyName in errors) {
      if (validatorMessages[propertyName]) {
        this.values = { value: errors[propertyName] };
        return validatorMessages[propertyName];
      } else if (this.customError) {
        return this.customError;
      }
    }
    return null;
  }

  private checkText(text: string) {
    this.message = text;
    this.type = this.messageType;
  }
}
